import ProfileView from "../../components/ProfileView";

const UserProfile = () => {
  return <ProfileView />;
};

export default UserProfile;
